/*
 * @Date: 2023-10-08 14:28:36
 * @Description: 基础库
 */
import Layout from "@/layout";
import { baseRef } from "../utils/baseRef";
export default [
  {
    path: "/taxrate",
    component: Layout,
    redirect: "/taxrate/goal",
    name: "data",
    meta: {
      title: "进口关税税率",
      icon: "iconfont iconshuilv1",
    },
    children: [
      {
        path: "goal",
        name: "goal",
        component: () => import("@/views/data/goods/common-theme/CommonTheme"),
        meta: baseRef["按目的地商品查询"],
      },
      {
        path: "sourceArea",
        name: "sourceArea",
        component: () => import("@/views/data/goods/common-theme/CommonTheme"),
        meta: baseRef["按原产地商品查询"],
      },
    ],
  },
  {
    path: "/data",
    component: Layout,
    redirect: "/data/goods",
    name: "data",
    meta: {
      title: "数据",
      icon: "iconfont iconshuju1",
    },
    children: [
      {
        path: "goods",
        name: "goodsTrade",
        redirect: "/data/goods/world",
        component: () => import("@/views/data/goods/common-theme"),
        meta: { title: "货物贸易" },
        children: [
          {
            path: "world",
            redirect: "/data/goods/world/monthly",
            newpath: "/data/goods/world/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "world",
            meta: { title: "世界" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: baseRef["世界月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: baseRef["世界年度"],
              },
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/world/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "EU",
            redirect: "/data/goods/EU/monthly",
            newpath: "/data/goods/EU/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "EU",
            meta: { title: "欧盟" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: baseRef["欧盟月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: baseRef["欧盟年度"],
              },
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/EU/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "asean",
            redirect: "/data/goods/asean/monthly",
            newpath: "/data/goods/asean/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "asean",
            meta: { title: "东盟" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: baseRef["东盟季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: baseRef["东盟年度"],
              },
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/asean/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "asia",
            redirect: "/data/goods/asia",
            component: () => import("@/views/data/goods/common-theme"),
            name: "asia",
            meta: { title: "亚洲" },
            children: [
              {
                path: "china",
                newpath: "/data/goods/asia/china/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "china",
                meta: {
                  title: "中国",
                  showOnlyOneChild: true,
                  icon: "iconshuju2 2-3-1",
                },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["中国月度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/china/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "HK",
                newpath: "/data/goods/asia/HK/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "HK",
                meta: { title: "中国香港", icon: "iconshuju2 2-3-3" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["中国香港月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["中国香港年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/chinaHK/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },

              {
                path: "Macao",
                newpath: "/data/goods/asia/Macao/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "Macao",
                meta: { title: "中国澳门", icon: "iconshuju2 2-3-3" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["中国澳门月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["中国澳门年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/chinaMacao/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              // ===== 中国台湾 ===== （2026-07-13 新增；排在中国澳门后）
              {
                path: "taiwan",
                newpath: "/data/goods/asia/taiwan/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "taiwan",
                meta: { title: "中国台湾", icon: "iconshuju2 2-3-10" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["台湾月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["台湾年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/taiwan/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "japan",
                newpath: "/data/goods/asia/japan/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "thailand",
                meta: { title: "日本", icon: "iconshuju2 2-3-2" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["日本月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["日本年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/japan/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "korea",
                newpath: "/data/goods/asia/korea/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "thailand",
                meta: { title: "韩国", icon: "iconshuju2 2-3-3" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["韩国月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["韩国年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/korea/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },

              {
                path: "thailand",
                newpath: "/data/goods/asia/thailand/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "thailand",
                meta: { title: "泰国", icon: "iconshuju2 2-3-4" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["泰国月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["泰国年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/thailand/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "philippines",
                newpath: "/data/goods/asia/philippines/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "philippines",
                meta: { title: "菲律宾", icon: "iconshuju2 2-3-5" },
                children: [
                  {
                    path: "monthly2023",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly2023",
                    meta: baseRef["菲律宾月度2023"],
                  },
                  {
                    path: "monthly2024",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly2024",
                    meta: baseRef["菲律宾月度2024"],
                  },
                  {
                    path: "annual2023",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual2023",
                    meta: baseRef["菲律宾年度2023"],
                  },
                  {
                    path: "annual2024",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual2024",
                    meta: baseRef["菲律宾年度2024"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/philippines/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "malaysia",
                newpath: "/data/goods/asia/malaysia/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "philippines",
                meta: { title: "马来西亚", icon: "iconshuju2 2-3-6" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["马来西亚月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    meta: baseRef["马来西亚年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/malaysia/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "indonesia",
                newpath: "/data/goods/asia/indonesia/detail",
                component: () => import("@/views/data/goods/common-theme"),
                name: "indonesia",
                meta: { title: "印度尼西亚", icon: "iconshuju2 2-3-7" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["印尼月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["印尼年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/asia/indonesia/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
            ],
          },
          {
            path: "AF",
            redirect: "/data/goods/AF/southAfrica",
            component: () => import("@/views/data/goods/common-theme"),
            name: "AF",
            meta: { title: "非洲" },
            children: [
              {
                path: "southAfrica",
                newpath: "/data/goods/AF/southAfrica/detail",
                redirect: "/data/goods/AF/southAfrica/monthly",
                component: () => import("@/views/data/goods/common-theme"),
                name: "southAfrica",
                meta: { title: "南非", icon: "iconshuju2 2-5-2" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["南非月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["南非年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/AF/southAfrica/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
            ],
          },
          {
            path: "europe",
            redirect: "/data/goods/europe/france",
            component: () => import("@/views/data/goods/common-theme"),
            name: "europe",
            meta: { title: "欧洲" },
            children: [
              {
                path: "france",
                newpath: "/data/goods/europe/france/detail",
                redirect: "/data/goods/europe/france/monthly",
                component: () => import("@/views/data/goods/common-theme"),
                name: "france",
                meta: { title: "法国", icon: "iconshuju2 2-5-2" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["法国月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["法国年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/europe/france/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
            ],
          },
          {
            path: "bmz",
            redirect: "/data/goods/bmz/jnd",
            component: () => import("@/views/data/goods/common-theme"),
            name: "bmz",
            meta: { title: "北美洲" },
            children: [
              {
                path: "USA",
                newpath: "/data/goods/bmz/USA/detail",
                redirect: "/data/goods/bmz/USA/monthbdck",
                component: () => import("@/views/data/goods/common-theme"),
                name: "USA",
                meta: { title: "美国", icon: "iconshuju2 2-4-1" },
                children: [
                  {
                    path: "monthbdck",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthbdck",
                    meta: baseRef["美国本地出口月度"],
                  },
                  {
                    path: "monthzck",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthzck",
                    meta: baseRef["美国总出口月度"],
                  },
                  {
                    path: "monthxfjk",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthybjk",
                    meta: baseRef["美国消费进口月度"],
                  },
                  {
                    path: "monthybjk",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "montybjk",
                    meta: baseRef["美国一般进口月度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/bmz/USA/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "jnd",
                newpath: "/data/goods/bmz/jnd/detail",
                redirect: "/data/goods/bmz/jnd/monthlyjc",
                component: () => import("@/views/data/goods/common-theme"),
                name: "jnd",
                meta: { title: "加拿大", icon: "iconshuju2 2-4-1" },
                children: [
                  {
                    path: "monthlyjc",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthlyjc",
                    meta: baseRef["加拿大本地出口月度"],
                  },
                  {
                    path: "monthlyj",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthlyj",
                    meta: baseRef["加拿大进口月度"],
                  },
                  {
                    path: "monthlyc",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthlyc",
                    meta: baseRef["加拿大总出口月度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/bmz/jnd/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
            ],
          },
          {
            path: "nmz",
            redirect: "/data/goods/nmz/brazil",
            component: () => import("@/views/data/goods/nmz"),
            name: "nmz",
            meta: { title: "南美洲" },
            children: [
              {
                path: "brazil",
                newpath: "/data/goods/nmz/brazil/detail",
                redirect: "/data/goods/nmz/brazil/monthly",
                component: () => import("@/views/data/goods/common-theme"),
                name: "brazil",
                meta: { title: "巴西", icon: "iconshuju2 2-5-3" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["巴西月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["巴西年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/nmz/brazil/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "argentina",
                newpath: "/data/goods/nmz/argentina/detail",
                redirect: "/data/goods/nmz/argentina/monthly",
                component: () => import("@/views/data/goods/common-theme"),
                name: "argentina",
                meta: { title: "阿根廷", icon: "iconshuju2 2-5-2" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["阿根廷月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["阿根廷年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/nmz/argentina/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "bilu",
                newpath: "/data/goods/nmz/bilu/detail",
                redirect: "/data/goods/nmz/bilu/monthly",
                component: () => import("@/views/data/goods/common-theme"),
                name: "bilu",
                meta: { title: "秘鲁", icon: "iconshuju2 2-5-1" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["秘鲁月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["秘鲁年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/nmz/bilu/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
              {
                path: "zhili",
                newpath: "/data/goods/nmz/zhili/detail",
                redirect: "/data/goods/nmz/zhili/monthly",
                component: () => import("@/views/data/goods/common-theme"),
                name: "zhili",
                meta: { title: "智利", icon: "iconshuju2 2-5-2" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["智利月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["智利年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/nmz/zhili/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
            ],
          },

          {
            path: "dyz",
            redirect: "/data/goods/dyz/xxl",
            component: () => import("@/views/data/goods/common-theme"),
            name: "dyz",
            meta: { title: "大洋洲" },
            children: [
              {
                path: "xxl",
                newpath: "/data/goods/dyz/xxl/detail",
                redirect: "/data/goods/dyz/xxl/monthly",
                component: () => import("@/views/data/goods/common-theme"),
                name: "xxl",
                meta: { title: "新西兰", icon: "iconshuju2 2-6-1" },
                children: [
                  {
                    path: "monthly",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "monthly",
                    meta: baseRef["新西兰月度"],
                  },
                  {
                    path: "annual",
                    component: () =>
                      import("@/views/data/goods/common-theme/CommonTheme"),
                    name: "annual",
                    meta: baseRef["新西兰年度"],
                  },
                  {
                    path: "detail",
                    hidden: true,
                    component: () =>
                      import("@/views/data/goods/dyz/xxl/detail"),
                    name: "detail",
                    meta: { title: "数据介绍" },
                  },
                ],
              },
            ],
          },

          {
            path: "singapore",
            redirect: "/data/goods/singapore/monthly",
            newpath: "/data/goods/singapore/detail",
            component: () => import("@/views/data/goods/singapore"),
            name: "singapore",
            hidden: true,
            meta: { title: "新加坡" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/singapore/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "brunei",
            redirect: "/data/goods/brunei/monthly",
            newpath: "/data/goods/brunei/detail",
            component: () => import("@/views/data/goods/brunei"),
            name: "brunei",
            hidden: true,
            meta: { title: "文莱" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/brunei/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "cambodia",
            redirect: "/data/goods/cambodia/monthly",
            newpath: "/data/goods/cambodia/detail",
            component: () => import("@/views/data/goods/cambodia"),
            name: "cambodia",
            hidden: true,
            meta: { title: "柬埔寨" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/cambodia/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "laos",
            redirect: "/data/goods/laos/monthly",
            newpath: "/data/goods/laos/detail",
            component: () => import("@/views/data/goods/laos"),
            name: "laos",
            hidden: true,
            meta: { title: "老挝" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/laos/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "myanmar",
            redirect: "/data/goods/myanmar/monthly",
            newpath: "/data/goods/myanmar/detail",
            component: () => import("@/views/data/goods/myanmar"),
            name: "myanmar",
            hidden: true,
            meta: { title: "缅甸" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/myanmar/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "vietnam",
            redirect: "/data/goods/vietnam/monthly",
            newpath: "/data/goods/vietnam/detail",
            component: () => import("@/views/data/goods/vietnam"),
            name: "vietnam",
            hidden: true,
            meta: { title: "越南" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/vietnam/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "australia",
            redirect: "/data/goods/australia/monthly",
            newpath: "/data/goods/australia/detail",
            component: () => import("@/views/data/goods/australia"),
            name: "australia",
            hidden: true,
            meta: { title: "澳大利亚" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/australia/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "UK",
            redirect: "/data/goods/UK/monthly",
            newpath: "/data/goods/UK/detail",
            component: () => import("@/views/data/goods/UK"),
            name: "UK",
            hidden: true,
            meta: { title: "英国" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/UK/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
          {
            path: "mexcico",
            redirect: "/data/goods/mexcico/monthly",
            newpath: "/data/goods/mexcico/detail",
            component: () => import("@/views/data/goods/mexcico"),
            name: "mexcico",
            hidden: true,
            meta: { title: "墨西哥" },
            children: [
              {
                path: "detail",
                hidden: true,
                component: () => import("@/views/data/goods/mexcico/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
        ],
      },
      {
        path: "service-trade",
        name: "serviceTrade",
        redirect: "/data/service-trade/world",
        component: () => import("@/views/data/service-trade"),
        meta: { title: "服务贸易" },
        children: [
          {
            path: "world",
            newpath: "/data/service-trade/world/detail",
            redirect: "/data/goods/world/annual",
            component: () => import("@/views/data/service-trade/world"),
            name: "world",
            meta: {
              title: "世界",
              showOnlyOneChild: true,
              icon: "iconshuju2 4-1",
            },
            children: [
              {
                path: "annual",
                component: () =>
                  import("@/views/data/service-trade/world/annual"),
                name: "annual",
                meta: { title: "世界年度" },
              },
              {
                path: "detail",
                hidden: true,
                component: () =>
                  import("@/views/data/service-trade/world/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
        ],
      },
      {
        path: "trade-index",
        name: "goodsIndex",
        redirect: "/data/goods-index/china",
        component: () => import("@/views/data/trade-index"),
        meta: { title: "贸易指数" },
        children: [
          {
            path: "china",
            newpath: "/data/trade-index/china/detail",
            redirect: "/data/goods/asia/china/monthly",
            component: () => import("@/views/data/trade-index/china"),
            name: "china",
            meta: {
              title: "中国",
              showOnlyOneChild: true,
              icon: "iconshuju2 3-1",
            },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/trade-index/china/monthly"),
                name: "monthly",
                meta: { title: "中国月度" },
              },
              {
                path: "detail",
                hidden: true,
                component: () =>
                  import("@/views/data/trade-index/china/detail"),
                name: "detail",
                meta: { title: "数据介绍" },
              },
            ],
          },
        ],
      },
    ],
  },
];
